module.exports = __webpack_public_path__ + "img/huafei_icon.720967c1.png";